{
  "GENERAL_SETTINGS": {
    "LIMIT_MESSAGES": {
      "CONVERSATION": "You have exceeded the conversation limit. Hacker plan allows only 500 conversations.",
      "INBOXES": "You have exceeded the inbox limit. Hacker plan only supports website live-chat. Additional inboxes like email, WhatsApp etc. require a paid plan.",
      "AGENTS": "You have exceeded the agent limit. Your plan only allows {allowedAgents} agents.",
      "NON_ADMIN": "Please contact your administrator to upgrade the plan and continue using all features."
    },
    "TITLE": "Nastavenia účtu",
    "SUBMIT": "Aktualizovať nastavenia",
    "BACK": "Späť",
    "DISMISS": "Dismiss",
    "UPDATE": {
      "ERROR": "Nastavenia sa nepodarilo aktualizovať, skúste to znova!",
      "SUCCESS": "Úspešne aktualizované nastavenia účtu"
    },
    "ACCOUNT_DELETE_SECTION": {
      "TITLE": "Delete your Account",
      "NOTE": "Once you delete your account, all your data will be deleted.",
      "BUTTON_TEXT": "Delete Your Account",
      "CONFIRM": {
        "TITLE": "Delete Account",
        "MESSAGE": "Deleting your Account is irreversible. Enter your account name below to confirm you want to permanently delete it.",
        "BUTTON_TEXT": "Vymazať",
        "DISMISS": "Zrušiť",
        "PLACE_HOLDER": "Please type {accountName} to confirm"
      },
      "SUCCESS": "Account marked for deletion",
      "FAILURE": "Could not delete account, try again!",
      "SCHEDULED_DELETION": {
        "TITLE": "Account Scheduled for Deletion",
        "MESSAGE_MANUAL": "This account is scheduled for deletion on {deletionDate}. This was requested by an administrator. You can cancel the deletion before this date.",
        "MESSAGE_INACTIVITY": "This account is scheduled for deletion on {deletionDate} due to account inactivity. You can cancel the deletion before this date.",
        "CLEAR_BUTTON": "Cancel Scheduled Deletion"
      }
    },
    "FORM": {
      "ERROR": "Prosím, opravte chyby vo formulári",
      "GENERAL_SECTION": {
        "TITLE": "Všeobecné nastavenia",
        "NOTE": ""
      },
      "ACCOUNT_ID": {
        "TITLE": "ID účtu",
        "NOTE": "Toto ID je potrebné, ak vytvárate integráciu založenú na rozhraní API"
      },
      "AUTO_RESOLVE": {
        "TITLE": "Auto-resolve conversations",
        "NOTE": "This configuration would allow you to automatically resolve the conversation after a certain period of inactivity.",
        "DURATION": {
          "LABEL": "Inactivity duration",
          "HELP": "Time period of inactivity after which conversation is auto-resolved",
          "PLACEHOLDER": "30",
          "ERROR": "Auto resolve duration should be between 10 minutes and 999 days",
          "API": {
            "SUCCESS": "Auto resolve settings updated successfully",
            "ERROR": "Failed to update auto resolve settings"
          }
        },
        "MESSAGE": {
          "LABEL": "Custom auto-resolution message",
          "PLACEHOLDER": "Conversation was marked resolved by system due to 15 days of inactivity",
          "HELP": "Message sent to the customer after conversation is auto-resolved"
        },
        "PREFERENCES": "Preferences",
        "LABEL": {
          "LABEL": "Add label after auto-resolution",
          "PLACEHOLDER": "Select a label"
        },
        "IGNORE_WAITING": {
          "LABEL": "Skip conversations waiting for agent’s reply"
        },
        "UPDATE_BUTTON": "Save Changes"
      },
      "NAME": {
        "LABEL": "Názov účtu",
        "PLACEHOLDER": "Názov vášho účtu",
        "ERROR": "Zadajte platný názov účtu"
      },
      "LANGUAGE": {
        "LABEL": "Site language",
        "PLACEHOLDER": "Názov vášho účtu",
        "ERROR": ""
      },
      "DOMAIN": {
        "LABEL": "Doména prichádzajúceho e-mailu",
        "PLACEHOLDER": "Doména, na ktorú budete dostávať e-maily",
        "ERROR": ""
      },
      "SUPPORT_EMAIL": {
        "LABEL": "E-mailová podpora",
        "PLACEHOLDER": "E-mailová podpora vašej spoločnosti",
        "ERROR": ""
      },
      "AUTO_RESOLVE_IGNORE_WAITING": {
        "LABEL": "Exclude unattended conversations",
        "HELP": "When enabled, the system will skip resolving conversations that are still waiting for an agent's reply."
      },
      "AUDIO_TRANSCRIPTION": {
        "TITLE": "Transcribe Audio Messages",
        "NOTE": "Automatically transcribe audio messages in conversations. Generate a text transcript whenever an audio message is sent or received, and display it alongside the message.",
        "API": {
          "SUCCESS": "Audio transcription setting updated successfully",
          "ERROR": "Failed to update audio transcription setting"
        }
      },
      "AUTO_RESOLVE_DURATION": {
        "LABEL": "Inactivity duration for resolution",
        "HELP": "Duration after a conversation should auto resolve if there is no activity",
        "PLACEHOLDER": "30",
        "ERROR": "Auto resolve duration should be between 10 minutes and 999 days",
        "API": {
          "SUCCESS": "Auto resolve settings updated successfully",
          "ERROR": "Failed to update auto resolve settings"
        },
        "UPDATE_BUTTON": "Update",
        "MESSAGE_LABEL": "Custom resolution message",
        "MESSAGE_PLACEHOLDER": "Conversation was marked resolved by system due to 15 days of inactivity",
        "MESSAGE_HELP": "This message is sent to the customer when a conversation is automatically resolved by the system due to inactivity."
      },
      "FEATURES": {
        "INBOUND_EMAIL_ENABLED": "Pre vaše konto je povolená kontinuita konverzácie s e-mailami.",
        "CUSTOM_EMAIL_DOMAIN_ENABLED": "Teraz môžete prijímať e-maily vo vlastnej doméne."
      }
    },
    "UPDATE_CHATWOOT": "K dispozícii je aktualizácia {latestChatwootVersion} pre Chatwoot. Prosím, aktualizujte svoju inštanciu.",
    "LEARN_MORE": "Learn more",
    "PAYMENT_PENDING": "Your payment is pending. Please update your payment information to continue using Chatwoot",
    "UPGRADE": "Upgrade to continue using Chatwoot",
    "LIMITS_UPGRADE": "Your account has exceeded the usage limits, please upgrade your plan to continue using Chatwoot",
    "OPEN_BILLING": "Open billing"
  },
  "FORMS": {
    "MULTISELECT": {
      "ENTER_TO_SELECT": "Stlačením tlačidla enter vyberte",
      "ENTER_TO_REMOVE": "Stlačením tlačidla enter vymažte",
      "NO_OPTIONS": "List is empty",
      "SELECT_ONE": "Vyberte jeden",
      "SELECT": "Select"
    }
  },
  "NOTIFICATIONS_PAGE": {
    "HEADER": "Upozornenia",
    "MARK_ALL_DONE": "Označiť všetky ako hotové",
    "DELETE_TITLE": "deleted",
    "UNREAD_NOTIFICATION": {
      "TITLE": "Unread Notifications",
      "ALL_NOTIFICATIONS": "View all notifications",
      "LOADING_UNREAD_MESSAGE": "Loading unread notifications...",
      "EMPTY_MESSAGE": "You have no unread notifications"
    },
    "LIST": {
      "LOADING_MESSAGE": "Načítavajú sa notifikácie...",
      "404": "Žiadne notifikácie",
      "TABLE_HEADER": [
        "Meno",
        "Telefónne číslo",
        "Konverzácie",
        "Naposledy kontaktovaný"
      ]
    },
    "TYPE_LABEL": {
      "conversation_creation": "Nová konverzácia",
      "conversation_assignment": "Konverzácia pridelená",
      "assigned_conversation_new_message": "Nová správa",
      "participating_conversation_new_message": "Nová správa",
      "conversation_mention": "Zmienka",
      "sla_missed_first_response": "SLA Missed",
      "sla_missed_next_response": "SLA Missed",
      "sla_missed_resolution": "SLA Missed"
    }
  },
  "NETWORK": {
    "NOTIFICATION": {
      "OFFLINE": "Offline",
      "RECONNECTING": "Reconnecting...",
      "RECONNECT_SUCCESS": "Reconnected"
    },
    "BUTTON": {
      "REFRESH": "Obnoviť"
    }
  },
  "COMMAND_BAR": {
    "SEARCH_PLACEHOLDER": "Hľadať alebo ísť na",
    "SNOOZE_PLACEHOLDER": "Type a time e.g. tomorrow, 2 hours, next friday, jan 15...",
    "SECTIONS": {
      "GENERAL": "Všeobecné",
      "REPORTS": "Reporty",
      "CONVERSATION": "Konverzácia",
      "BULK_ACTIONS": "Bulk Actions",
      "CHANGE_ASSIGNEE": "Zmeniť prideleného agenta",
      "CHANGE_PRIORITY": "Change Priority",
      "CHANGE_TEAM": "Zmeniť tím",
      "SNOOZE_CONVERSATION": "Snooze Conversation",
      "ADD_LABEL": "Pridať štítok do konverzácie",
      "REMOVE_LABEL": "Odstrániť štítok z konverzácie",
      "SETTINGS": "Nastavenia",
      "AI_ASSIST": "AI Assist",
      "APPEARANCE": "Appearance",
      "SNOOZE_NOTIFICATION": "Snooze Notification"
    },
    "COMMANDS": {
      "GO_TO_CONVERSATION_DASHBOARD": "Prejsť na ovládací panel konverzácie",
      "GO_TO_CONTACTS_DASHBOARD": "Prejsť na ovládací panel kontaktov",
      "GO_TO_REPORTS_OVERVIEW": "Prejsť na prehľad reportov",
      "GO_TO_CONVERSATION_REPORTS": "Go to Conversation Reports",
      "GO_TO_AGENT_REPORTS": "Prejsť na reporty o agentoch",
      "GO_TO_LABEL_REPORTS": "Prejsť na reporty o štítkoch",
      "GO_TO_INBOX_REPORTS": "Prejsť na reporty o schránkach",
      "GO_TO_TEAM_REPORTS": "Prejsť na reporty o tímoch",
      "GO_TO_SETTINGS_AGENTS": "Prejsť na nastavenia agentov",
      "GO_TO_SETTINGS_TEAMS": "Prejsť na nastavenia tímov",
      "GO_TO_SETTINGS_INBOXES": "Prejsť na nastavenia chránok",
      "GO_TO_SETTINGS_LABELS": "Prejsť na nastavenia štítkov",
      "GO_TO_SETTINGS_CANNED_RESPONSES": "Prejsť na nastavenia uložených odpovedí",
      "GO_TO_SETTINGS_APPLICATIONS": "Go to Application Settings",
      "GO_TO_SETTINGS_ACCOUNT": "Go to Account Settings",
      "GO_TO_SETTINGS_PROFILE": "Go to Profile Settings",
      "GO_TO_NOTIFICATIONS": "Go to Notifications",
      "ADD_LABELS_TO_CONVERSATION": "Pridať štítok do konverzácie",
      "ASSIGN_AN_AGENT": "Assign an agent",
      "AI_ASSIST": "AI Assist",
      "ASSIGN_PRIORITY": "Assign priority",
      "ASSIGN_A_TEAM": "Assign a team",
      "MUTE_CONVERSATION": "Mute conversation",
      "UNMUTE_CONVERSATION": "Unmute conversation",
      "REMOVE_LABEL_FROM_CONVERSATION": "Odstrániť štítok z konverzácie",
      "REOPEN_CONVERSATION": "Reopen conversation",
      "RESOLVE_CONVERSATION": "Resolve conversation",
      "SEND_TRANSCRIPT": "Send an email transcript",
      "SNOOZE_CONVERSATION": "Snooze Conversation",
      "UNTIL_NEXT_REPLY": "Until next reply",
      "UNTIL_NEXT_WEEK": "Until next week",
      "UNTIL_TOMORROW": "Until tomorrow",
      "UNTIL_NEXT_MONTH": "Until next month",
      "AN_HOUR_FROM_NOW": "Until an hour from now",
      "UNTIL_CUSTOM_TIME": "Custom...",
      "CHANGE_APPEARANCE": "Change Appearance",
      "LIGHT_MODE": "Light",
      "DARK_MODE": "Dark",
      "SYSTEM_MODE": "System",
      "SNOOZE_NOTIFICATION": "Snooze Notification"
    }
  },
  "DASHBOARD_APPS": {
    "LOADING_MESSAGE": "Loading Dashboard App..."
  },
  "COMMON": {
    "OR": "Or",
    "CLICK_HERE": "kliknite sem"
  }
}
